import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const PublishControls = ({ onSaveDraft, onPublish, saving, publishing, lastSaved }) => {
  const [reviewChecked, setReviewChecked] = useState(false);
  const [effectiveDate, setEffectiveDate] = useState('');

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5 space-y-4">
      <h3 className="font-semibold text-gray-900 flex items-center gap-2">
        <Icon name="Send" size={16} className="text-accent" />
        Publication Controls
      </h3>
      {/* Effective Date */}
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1.5">Effective Date</label>
        <input
          type="date"
          value={effectiveDate}
          onChange={(e) => setEffectiveDate(e?.target?.value)}
          className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-accent/40 focus:border-accent"
        />
      </div>
      {/* Review Checkbox */}
      <label className="flex items-start gap-3 cursor-pointer">
        <input
          type="checkbox"
          checked={reviewChecked}
          onChange={(e) => setReviewChecked(e?.target?.checked)}
          className="mt-0.5 w-4 h-4 rounded border-gray-300 text-accent focus:ring-accent"
        />
        <span className="text-sm text-gray-700">
          I confirm this document has been reviewed for legal compliance and is ready for publication.
        </span>
      </label>
      {/* Last Saved */}
      {lastSaved && (
        <p className="text-xs text-gray-400 flex items-center gap-1">
          <Icon name="Clock" size={12} />
          Last saved: {lastSaved}
        </p>
      )}
      {/* Actions */}
      <div className="flex gap-2 pt-1">
        <button
          onClick={onSaveDraft}
          disabled={saving}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-60"
        >
          {saving ? <Icon name="Loader2" size={14} className="animate-spin" /> : <Icon name="Save" size={14} />}
          Save Draft
        </button>
        <button
          onClick={onPublish}
          disabled={publishing || !reviewChecked}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-accent text-accent-foreground rounded-lg text-sm font-medium hover:bg-accent/90 transition-colors disabled:opacity-60"
        >
          {publishing ? <Icon name="Loader2" size={14} className="animate-spin" /> : <Icon name="Globe" size={14} />}
          Publish
        </button>
      </div>
      {!reviewChecked && (
        <p className="text-xs text-amber-600 flex items-center gap-1">
          <Icon name="AlertCircle" size={12} />
          Check the review confirmation to enable publishing.
        </p>
      )}
    </div>
  );
};

export default PublishControls;
